module.exports = __webpack_public_path__ + "img/error.a77ff816.webp";